/** How the backend stores a checkbox custom field's value as a string. */
export const CheckboxCustomFieldValues = {
  CHECKED: 'True',
  UNCHECKED: 'False',
} as const
